import type { ComponentProps } from "react";

export function Check(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				fill="currentColor"
				d="M13.896 5.747A.9.9 0 0 1 15.353 6.8l-4.607 7.105a1.5 1.5 0 0 1-2.174.373l-.132-.115-3.664-3.574-.063-.067a.9.9 0 0 1 1.25-1.282l.069.06 2.966 2.893a.5.5 0 0 0 .768-.086l4.077-6.285.053-.075Z"
			/>
		</svg>
	);
}
